import $ from "jquery";
import 'jquery.maskedinput/src/jquery.maskedinput';
import datepickerFactory from 'jquery-datepicker';
import datepickerRUFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-ru';
//import Carousel from './carousel';
import MobileDetect from './mobile';

window.$ = window.jQuery = $;

datepickerFactory($);
datepickerRUFactory($);

window.VIDEOJS_NO_DYNAMIC_STYLE = true;

window.defaultFormTitles = {
    'ru': {'error': 'Ошибка!', 'success': 'Спасибо!'},
    'en': {'error': 'Error!', 'success': 'Thanks!'},
    'de': {'error': 'Error!', 'success': 'Danke!'}
};

window.defaultFormMessages = {
    'ru': {'error': 'Ваш запрос не был отправлен.<br>Попробуйте позже еще раз.', 'success': 'Ваш запрос был успешно отправлен!<br>Мы вам скоро перезвоним.'},
    'en': {'error': 'The request cannot be sent.<br>Please try again later.', 'success': 'You have succesfully sent the request!<br>We will call you back soon.'},
    'de': {'error': 'Die Anfrage kann nicht gesendet werden.<br>Bitte versuchen Sie es später erneut.', 'success': 'Sie haben die Anfrage erfolgreich gesendet!<br>Wir rufen Sie bald zurück.'}
};


class Main {

    Init = () => {
        $('.menu .phone').attr('href','tel:'+$('.menu .phone').text());

        $(".arrow").bind("click", function(){
            let anchor = $(this).attr('data-href');
            $('html,body').animate({
                scrollTop: $(anchor).offset().top
            }, 1000);
        });

        $("header .nav__item").hover(function(){
            if(!$(this).hasClass('active') && $(this).find('.nav__item__submenu').length>0){
                $("header .nav__item.active").addClass('hide_sub');
            }
        }, function(){
            $("header .nav__item.active").removeClass('hide_sub');
        });

        $(".main-slider__title__in").hover(function(){
            $('.watch-link').addClass('hide');
            $('.main-slider__video video').css('z-index','-1');
            //let video = $('.main-slider__video video').get(0);
            //    video.stop();
        }, function(){
            $('.watch-link').removeClass('hide');
            $('.main-slider__video video').css('z-index','');

        });

        if($('.main-slider__video video').length){
            let video = $(".main-slider__video video");
            video.attr('controls','controls');//Добавляем к тегу видел контролы
            video.get(0).play();//Автозапуск
        }

        $(".menu-toggle").bind("click", function(){
            $("body").toggleClass("menu-opened");
            //$("html,body").animate({"scrollTop": 0}, 50);
        });

        this.LogoAnim();
        this.Forms();

        function fix_menu_mob(){
            if($(window).scrollTop()>0){
                $('header').addClass('fix_menu_mob');
            }else{
                $('header').removeClass('fix_menu_mob');
            }
        }
        fix_menu_mob();
        $(window).scroll(function(){
            fix_menu_mob();
        });

        function itismobile(){
            $('.main-slider__video video').remove();
            $('.main-slider__video').addClass('main-slider__video__img');
        }
        if(MobileDetect.Init()){
            itismobile();
        }


        let check_lang_link = false;
        $(".languages a").bind("click", function(e){
            if(MobileDetect.Init() && !check_lang_link){
                e.preventDefault();
                e.stopPropagation();
                check_lang_link = true;
                $('.languages').addClass('opened');
            }
        });

        //let check_menu_link = false;
        $(".nav__item__main-link").bind("click", function(e){
            if(MobileDetect.Init() && !$(this).parent().hasClass('active') && $(this).parent().find('.nav__item__submenu').length>0){
                e.preventDefault();
                e.stopPropagation();
                $('.nav__item').removeClass('active');
                $(this).parent().addClass('active');
            }
        });


        $(".food-popup-link").bind("click", function(e){
            e.preventDefault();
            var popup_block = $(this).parents('.quick-facts__item').find('.food-popup');

            $.fancybox.open(popup_block, {
                type: 'inline',
                touch:false,
                hideScrollbar: true,
                animationEffect: "zoom-in-out",
                animationDuration: 500,
                opts: {
                    touch: false,
                },
                mobile: {
                    touch: false,
                },
                helpers: {
                    overlay: { locked: false }
                },
                afterShow: function () {
                    //$('.food-popup__gallery .owl-item.active').addClass('loaded');
                },
            });


        });





    };

    
    LogoAnim = () => {
        (function(a) {
            a.fn.circliful = function(b, d) {
                let c = a.extend({
                    fgcolor: "#556b2f",
                    bgcolor: "#eee",
                    fill: false,
                    width: 15,
                    dimension: 200,
                    fontsize: 15,
                    percent: 50,
                    animationstep: 5,
                    iconsize: "20px",
                    iconcolor: "#999",
                    border: "default",
                    complete: null
                }, b);
                return this.each(function() {
                    let w = ["fgcolor", "bgcolor", "fill", "width", "dimension", "fontsize", "animationstep", "endPercent", "icon", "iconcolor", "iconsize", "border"];
                    let f = {};
                    let F = "";
                    let n = 0;
                    let t = a(this);
                    let A = false;
                    let v, G;
                    t.addClass("circliful");
                    e(t);

                    if (a(this).data("total") != undefined && a(this).data("part") != undefined) {
                        let I = a(this).data("total") / 100;
                        let percent = ((a(this).data("part") / I) / 100).toFixed(3);
                        n = (a(this).data("part") / I).toFixed(3)
                    } else {
                        if (a(this).data("percent") != undefined) {
                            let percent = a(this).data("percent") / 100;
                            n = a(this).data("percent")
                        } else {
                            let percent = c.percent / 100
                        }
                    }

                    let i = a("<canvas></canvas>").attr({
                        width: f.dimension,
                        height: f.dimension
                    }).appendTo(a(this)).get(0);
                    let g = i.getContext("2d");
                    let r = i.width / 2;
                    let q = i.height / 2;
                    let C = f.percent * 360;
                    let H = C * (Math.PI / 180);
                    let l = i.width / 2.5;
                    let B = 2.3 * Math.PI;
                    let z = 0;
                    let E = false;
                    let o = f.animationstep === 0 ? n : 0;
                    let p = Math.max(f.animationstep, 0);
                    let u = Math.PI * 2;
                    let h = Math.PI / 0.85;
                    let j = "";
                    let k = true;
                    if (a(this).data("type") != undefined) {
                        j = a(this).data("type");
                        if (j == "half") {
                            B = 2 * Math.PI;
                            z = 3.13;
                            u = Math.PI * 1;
                            h = Math.PI / 0.996
                        }
                    }

                    function e(x) {
                        a.each(w, function(y, J) {
                            if (x.data(J) != undefined) {
                                f[J] = x.data(J)
                            } else {
                                f[J] = a(c).attr(J)
                            }
                            if (J == "fill" && x.data("fill") != undefined) {
                                A = true
                            }
                        })
                    }

                    function m(x) {
                        g.clearRect(0, 0, i.width, i.height);
                        g.beginPath();
                        g.arc(r, q, l, z, B, false);
                        g.lineWidth = f.width + 1;
                        g.strokeStyle = f.bgcolor;
                        g.stroke();
                        if (A) {
                            g.fillStyle = f.fill;
                            g.fill()
                        }
                        g.beginPath();
                        g.arc(r, q, l, -(h), ((u) * x) - h, false);
                        if (f.border == "outline") {
                            g.lineWidth = f.width + 13
                        } else {
                            if (f.border == "inline") {
                                g.lineWidth = f.width - 13
                            }
                        }
                        g.strokeStyle = f.fgcolor;
                        g.stroke();
                        if (o < n) {
                            o += p;
                            requestAnimationFrame(function() {
                                m(Math.min(o, n) / 100)
                            }, t)
                        }
                        if (o == n && k && typeof(b) != "undefined") {
                            if (a.isFunction(b.complete)) {
                                b.complete();
                                k = false
                            }
                        }
                    }
                    m(o / 100);

                    setTimeout(function () {
                        /*
                        if($('.main--video').length){
                            //if(!MobileDetect.Init() && $('.main--video').length){
                        }else{
                            document.querySelector('body').classList.add('ready');
                        }*/
                        document.querySelector('body').classList.add('ready');
                    },300);
                })
            }
        }(jQuery));
        $('.logo_circle').circliful();
    };


    Forms = () => {

        /*
const Ml2WebForms_'.$this->webForm->getId().' = {
    showFormMessage: function(result){
        const defaultFormTitles = {
            \'ru\': {\'error\': \'Ошибка!\', \'success\': \'Спасибо!\'},
            \'en\': {\'error\': \'Error!\', \'success\': \'Thanks!\'},
            \'de\': {\'error\': \'Error!\', \'success\': \'Danke!\'}
    };
        let p = $(\'#alert\');
        let lang = $(\'html\').attr(\'lang\');
        let title = defaultFormTitles[lang].error;
        let message = result.message;
        if (!p.length) {
            $(\'body\').append(\'<div class="popup alert" id="alert"><div class="popup__title"></div><div class="popup__text"></div></div>\');
            p = $(\'#alert\');
        }
        p.find(\'.popup__title\').html(title);
        p.find(\'.popup__text\').html(message);
        $.fancybox.open(p, {
            type: \'inline\',
        opts: {
            touch: false,
                animationEffect: \'zoom-in-out\',
            animationDuration: 500
        }
    });
    }
};
 */

        function validateEmail(email) {
            let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        function validateForm(form) {
            let check = true;
            //form.find('.input').removeClass('error');

            form.find('.req:visible').each(function() {
                if($(this).find('input').val()===''){
                    $(this).addClass('error');
                    check = false;
                }else{
                    $(this).removeClass('error')
                }
            });
            if(!validateEmail(form.find('.email').find('input').val())){
                form.find('.email').addClass('error');
                check = false;
            }else{
                form.find('.email').removeClass('error');
            }
            return check;
        }

        function validateInput(input_in){
            let parent = input_in.parent('.input');
            if(parent.hasClass('error')){
                if(parent.hasClass('req') && input_in.val()!==''){
                    if(parent.hasClass('email')){
                        if(validateEmail(input_in.val())){
                            parent.removeClass('error');
                        }
                    }else{
                        parent.removeClass('error');
                    }
                }
            }
        }

        function getFormData(f){
            let unindexed_array = f.serializeArray();
            let indexed_array = {};
            $.map(unindexed_array, function(n, i) {
                let name = n['name'];
                let value = n['value'];
                if (name.indexOf('[]') != -1) {
                    if (!indexed_array[name]) {
                        indexed_array[name] = [];
                    }
                    indexed_array[name].push(value);
                }
                else {
                    indexed_array[name] = value;
                }
            });
            return indexed_array;
        }

        $('form .phone input').mask('+7(999) 999-9999', {autoclear: true});
        $('form .time input').mask('99:99 - 99:99', {autoclear: true});
        $.datepicker.regional['ru'] = {
            monthNames: ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
            dayNamesMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
            dateFormat: 'dd.mm.yy',
            firstDay: 1,
            prevText: '',
            nextText: '',
            showOtherMonths: true,
            buttonText: '',
            numberOfMonths: 1,
            changeMonth: false,
            changeYear: false,
            minDate: 0,
            yearRange: '0:+1',
            defaultDate: null,
            buttonText: null
        };
        $('form .date input').each(function() {
            var inp = $(this);
            inp.datepicker($.datepicker.regional['ru']);
            inp.bind('click', function() {
                $(this).datepicker('show');
            });
        });

        $('form input').bind('change input paste', function() {
            validateInput($(this));
        });

        function showFormMessage(title, message, error){
            var p = $('#alert');
            if (!p.length) {
                $('body').append('<div class="popup alert" id="alert"><div class="popup__title"></div><div class="popup__text"></div></div>');
                p = $('#alert');
            }
            p.find('.popup__title').html(title);
            p.find('.popup__text').html(message);

            if(!error){
                $.fancybox.close($('#request'));
                $.fancybox.close($('#request_ab'));
            }

            $.fancybox.open($('#alert'), {
                type: 'inline',
                touch: {
                    vertical: false,
                },
                hideScrollbar: true,
                opts: {
                    touch: false,
                    animationEffect: 'zoom-in-out',
                    animationDuration: 500
                }
            });
        }

        $('form').bind('submit', function(e) {
            let f = $(this);
            if (!validateForm(f)) {
                e.preventDefault();
                return false;
            }

            if (f.parent().attr('data-ajax')) {
                let url = f.attr('action');
                let data = getFormData(f);
                let lang = $('html').attr('lang');
                $.post(url, data, function(response) {
                    response = $.parseJSON(response);
                    let title = '';
                    let message = '';
                    if (response.error) {
                        title = defaultFormTitles[lang].error;
                        message = response.message || defaultFormMessages[lang].error;
                    }
                    else {
                        title = defaultFormTitles[lang].success;
                        message = response.message || defaultFormMessages[lang].success;
                        f.find('input[type="text"], textarea').val('');
                    }
                    showFormMessage(title, message);
                }).fail(function() {
                    showFormMessage(defaultFormTitles[lang].error, defaultFormMessages[lang].error, true);
                });
                e.preventDefault();
                return false;
            }
        });


        /*
        var Ml2WebForms_callback = {
            webform: null,
            error: false,
            webform_id: '<?php echo $arParams['ID']?>',

            // init webform script
            init: function() {
            },

            showFormMessage: function(title, message) {
                var p = $('#alert');
                if (!p.length) {
                    $('body').append('<div class="popup alert" id="alert"><div class="popup__title"></div><div class="popup__text"></div></div>');
                    p = $('#alert');
                }
                p.find('.popup__title').html(title);
                p.find('.popup__text').html(message);
                $.fancybox.open($('#alert'), {
                    type: 'inline',
                    opts: {
                        touch: false,
                        animationEffect: 'zoom-in-out',
                        animationDuration: 500
                    }
                });
            },

            showResult: function(result) {
                //console.log(Ml2WebForms_request);
                var modalwindow = $('.modal input[name="form_id"][value="'+result.form_id+'"]').closest('.modal');
                var f = $('form#ml2webforms_callback');
                var lang = $('html').attr('lang');
                var title = '', message = '';

                // if form result success show message and hide errors
                if (result.status == 'success') {
                    title = defaultFormTitles[lang].success;
                    message = result.message || defaultFormMessages[lang].success;
                    f.find('input[type="text"], textarea').val('');
                    if (typeof yaCounter50881799 != 'undefined') {
                        yaCounter50881799.reachGoal('bellmanager');
                    }
                } else if (result.status == 'failure') {
                    title = defaultFormTitles[lang].error;
                    message = result.message || defaultFormMessages[lang].error;
                }
                if (message != '') {
                    Ml2WebForms_callback.showFormMessage(title, message);
                }
            }
        };

        // init webform on document load
        if (typeof window.addEventListener != 'undefined') {
            window.addEventListener("load", function() { Ml2WebForms_<?php echo $arParams['ID']?>.init(); }, false);
            if (typeof MlWebFAS != 'undefined') {
                MlWebFAS.init();
            }
        } else {
            window.attachEvent("onload", function() { Ml2WebForms_<?php echo $arParams['ID']?>.init(); });
            if (typeof MlWebFAS != 'undefined') {
                MlWebFAS.init();
            }
        }
         */

    };


}


export default new Main;